<template>
  <div class="modal-body">
    <div class="modal-guest-gallery d-flex flex-column justify-content-center align-items-center" v-if="galleryDetails">
      <h5 class="mb-2">{{ translate.home.guestGallery.unlockPremiumContent }}</h5>
      <p class="mb-0 text-center" v-html="fillTranslateParams(
                                        isVideoUploadEnabled ? translate.home.guestGallery.unlock : translate.home.guestGallery.unlockPhotosOnly,
                                        {
                                                    username: galleryDetails.username,
                                                    photos: galleryDetails.photoQuantity,
                                                    videos: galleryDetails.videoQuantity,
                                                 }
                                        )"
      >
      </p>
      <button-with-loading-component
        :loading="loading"
        :disabled="loading"
        @click.native="buyAsGuestThrottled"
        class="w-100 btn btn-rebrand-primary btn-rebrand-sm mt-4 mb-2"
        :text="translate.home.guestGallery.purchaseWithoutAccount"
      ></button-with-loading-component>

      <div class="payment-methods-logos mb-3" aria-hidden="true">
        <img :src="regionRelativeUrl('/images/visa-57x18.png')" alt="Visa" height="14">
        <img :src="regionRelativeUrl('/images/mastercard-symbol-46x33.png')" alt="Mastercard" height="22">
        <img :src="regionRelativeUrl('/images/payments/google-pay.webp')" alt="Google Pay" height="22">
        <img :src="regionRelativeUrl('/images/payments/apple-pay.svg')" alt="Apple Pay" height="22">
      </div>

      <span>{{ translate.home.guestGallery.or }}</span>

      <span class="w-100 btn btn-rebrand-primary-outline btn-rebrand-sm mt-4 mb-1 cursor-pointer" @click="$emit('signIn')">
        {{ translate.home.guestGallery.signInAndPurchase }}
      </span>

      <p class="w-100 text-center save-text">{{ translate.home.guestGallery.saveUpToOnYourPurchase }}</p>

      <span class="already-paid-text text-center mb-2">{{ translate.home.guestGallery.alreadyPaid }}</span>

      <span class="w-100 error-input-container" :class="{'has-error': codeError || codeIsExpired}">
        <input type="number" class="w-100 form-control-v2 text-center" min="0" max="999999"
               :placeholder="translate.login.phoneVerification.enterCodeHere"
               v-model.trim.number="code"
        >
      </span>
      <error-component :message="translate.home.guestGallery.codeIsWrong" class="text-center px-0" v-if="codeError"></error-component>
      <error-component :message="translate.home.guestGallery.codeIsExpired" class="text-center px-0" v-if="codeIsExpired"></error-component>
    </div>
  </div>
</template>


<script>
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent";
import translateMixin from "@/components/mixins/translateMixin";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {throttle} from "lodash";
import {mapState} from "vuex";

const data = () => {
  return {
    code: null,
    codeError: false,
    codeIsExpired: false,
    codeLength: 6,
    loading: false,
  }
}

function created() {
  this.onCodeSubmittedThrottled = throttle(this.onCodeSubmittedThrottled, 2000)
  this.buyAsGuestThrottled = throttle(this.buyAsGuestThrottled, 2000)
}

async function onCodeSubmittedThrottled() {
  const codeIsValid = await this.callCheckCode()

  if (codeIsValid) {
    this.$emit('onCodeInput')
  }
}

async function callCheckCode() {
  const [err, response] = await to(api.gallery.guest.checkCode(this.galleryDetails.id, this.code))

  if (!err) {
    return response.status === 204;
  }

  if (err.response && err.response.status === 422) {
    this.codeIsExpired = true;

    return false;
  }

  this.codeError = true;

  return false;
}

async function buyAsGuestThrottled() {
  this.loading = true;

  const apiCall = this.galleryDetails.all
      ? api.gallery.guest.createCheckoutUrlPurchaseAll(this.galleryDetails.ownerId || this.galleryDetails.userId)
      : api.gallery.guest.createCheckoutUrl(this.galleryDetails.id);

  const [err, response] = await to(apiCall);

  const url = _.get(response, 'data.results.redirectUrl');

  if (err || !url) {
    this.loading = false;
    return toastr.error(this.translate.home.errorCommon);
  }

  this.loading = false;
  $('#loginOrRegister').modal('hide');

  window.location.href = url;
}

export default {
  data,
  created,
  components: {ButtonWithLoadingComponent},
  mixins: [translateMixin, regionsUrlMixin],
  props: ['galleryDetails'],
  computed: {
    ...mapState(['regionData']),
    isVideoUploadEnabled() {
      return !_.has(this.regionData, 'sectionsToHide.videoUpload');
    },
    unlockTranslationKey() {
      return this.isVideoUploadEnabled ? 'translate.home.guestGallery.unlock' : 'translate.home.guestGallery.unlockPhotosOnly';
    },
  },
  watch: {
    code() {
      this.codeError = false;
      this.codeIsExpired = false;

      const length = String(this.code).length;
      if (length === this.codeLength) {
        return this.onCodeSubmittedThrottled()
      }

      if (length > this.codeLength) {
        this.code = Number(String(this.code).substring(0, this.codeLength))
      }
    }
  },
  methods: {
    onCodeSubmittedThrottled,
    callCheckCode,
    buyAsGuestThrottled,
  }
}

</script>

